// src/router/routerIndex.js
import React from 'react';
import Report from '@/page/Report/index.js';
import NewChat from '@/page/NewChat/index.js';
import HomePage from '@/page/Home/index.js';
import NotFound from '@/page/NotFound/index.js';
import { createBrowserRouter } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
    children: [
      {
        index: true,
        element: <NewChat isFromHome={true} />,
      },
      {
        path: '/chat/:externalRef',
        element: <NewChat />,
      },
      {
        path: '/report/:externalRef',
        element: <Report />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
